module.exports = {
  name: "Unlimish",
  shortName: "Unlimish",
  description: "Hi, I'm Unlimish.",
  url: "https://unlimi.sh", // Domain of your site without prefix!
  prefix: "/",
  author: "Unlimish",
  twitter: "unlimish",
}
